// import { objKeyName } from "helper/utils";
import _ from "lodash";

export const UAA_PATH = "/uaa";

export const TRANSLATE_UAA = {
  PERMISSION_CONFIG: `${UAA_PATH}/permission-config`,
  SYSTEM_MANAGEMENT: `${UAA_PATH}/system-management`,
  API_MANAGEMENT: `${UAA_PATH}/api-management`,
  SERVICE: `${UAA_PATH}/service`,
  FEATURE: `${UAA_PATH}/feature`,
  USER: `${UAA_PATH}/user`,
  CONFIGURATION_MENU: `${UAA_PATH}/configuration-menu`,
  CONFIG_DISPLAY_SYSTEM: `${UAA_PATH}/config-display-system`,
  SCREEN_DASHBOARD: `${UAA_PATH}/screen-dashboard`,
};

export const UAA_CHILDREN_PATH = {
  OVERVIEW: `${UAA_PATH}/overview`,
  DETAIL_CHANNEL: `${UAA_PATH}/detail-channel/:id`,
  UPDATE_APPROVE_UPDATE: `${UAA_PATH}/update-channel/approve-request/update/:id`,
  //Register
  REGISTER_CREATE_REQUEST: `${UAA_PATH}/register-channel/create-request`,
  REGISTER_APPROVE_REQUEST: `${UAA_PATH}/register-channel/approve-request`,
  REGISTER_APPROVE_REQUEST_APPROVE: `${UAA_PATH}/register-channel/approve-request/:id`,
  //Update
  UPDATE_APPROVE_REQUEST: `${UAA_PATH}/update-channel/approve-request`,
  UPDATE_APPROVE_APPROVE: `${UAA_PATH}/update-channel/approve-request/:id`,
  //cancel
  CANCEL_APPROVE_REQUEST: `${UAA_PATH}/cancel-channel/approve-request`,
  CANCEL_APPROVE_APPROVE: `${UAA_PATH}/cancel-channel/approve-request/:id`,
  //Manager Sys User
  MANAGE_SYS_USER_LIST: `${UAA_PATH}/channel/manage-sys-user`,
  MANAGE_SYS_USER_CREATE: `${UAA_PATH}/channel/manage-sys-user/create`,
  MANAGE_SYS_USER_UPDATE: `${UAA_PATH}/channel/manage-sys-user/update`,
  MANAGE_SYS_USER_DETAIL: `${UAA_PATH}/channel/manage-sys-user/detail`,
  //Funding Management
  REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/request-clear-debit-channel`,
  DETAIL_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/request-clear-debit-channel/:id`,
  CREATE_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/create-request-clear-debit-channel`,
  APPROVE_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/approve-request-clear-debit-channel`,
  DETAIL_APPROVE_REQUEST_CLEAR_DEBIT_CHANNEL: `${UAA_PATH}/approve-request-clear-debit-channel/:id`,

  FUNDING_REQUEST_CASH: `${UAA_PATH}/request-cash-in`,
  FUNDING_APPROVE_CASH: `${UAA_PATH}/approve-cash-in`,
  //Funding Management End

  //Report
  REPORT_CHANNEL: `${UAA_PATH}/report-channel`,
  REPORT_TOTAL_DEBIT: `${UAA_PATH}/report-total-debit`,
  REPORT_DETAIL_DEBIT: `${UAA_PATH}/report-detail-debit`,

  //End Report

  //master
  PERMISSION_CONFIG: `${UAA_PATH}/permission-config`,
  CREATE_PERMISSION_CONFIG: `${UAA_PATH}/permission-config/:id`,
  USER_MANAGEMENT: `${UAA_PATH}/user-management`,
  SYSTEM_MANAGEMENT: `${UAA_PATH}/system-management`,
  COMPANY_PERMISSION: `${UAA_PATH}/company-permission`,
  API_MANAGEMENT: `${UAA_PATH}/api-management`,
  SERVICE: `${UAA_PATH}/service`,
  FEATURE: `${UAA_PATH}/feature`,
  CONFIGURATION_MENU: `${UAA_PATH}/configuration-menu`,
  CONFIG_DISPLAY_SYSTEM: `${UAA_PATH}/config-display-system`,
  SCREEN_DASHBOARD: `${UAA_PATH}/screen-dashboard`,
};

export const STORAGE = {
  TOKEN: "token",
  REFRESH_TOKEN: "refreshToken",
  USER: "userInformation",
};

export const Option = {
  ALL: "ALL",
  NONE: "NONE",
  SYSTEM: "SYSTEM",
  realYears: new Date().getFullYear(),
};

const objKeyName = (obj, name) =>
  _.find(_.keys(obj), (x) => _.isEqual(x, name));

export const OptionsALL = [
  { label: objKeyName(Option, Option.ALL), value: Option.ALL },
];

export const CHANNEL_STATE_SEARCH = {
  ACTIVE: 10,
  CANCELLED: -2,
  WAITING_CANCEL: -3,
  LOCK: -4,
  // BLOCKED: -1,
  // WITHOUT_CONTRACT: "WITHOUT_CONTRACT",
  // "REGISTER_-_PENDING_APPROVAL": 8,
  // "REGISTER_-_REJECTED": 11,
  // "REGISTER_-_REVIEWED": 12,
  // "UPDATE_-_PENDING_APPROVAL": 9,
  // "UPDATE_-_REJECTED": 14,
  // "UPDATE_-_REVIEWED": 15,
  // RECENTLY_UPDATE: 13,
};

export const CHANNEL_STATE = {
  "REGISTER_-_PENDING_APPROVAL": 8,
  "REGISTER_-_REJECTED": 11,
  "REGISTER_-_REVIEWED": 12,
  "REGISTER_-_APPROVED": 10,
  "UPDATE_-_PENDING_APPROVAL": 9,
  "UPDATE_-_REJECTED": 14,
  "UPDATE_-_REVIEWED": 15,
  "UPDATE_-_APPROVED": 13,
  "CANCEL_-_PENDING_APPROVAL": 16,
  "CANCEL_-_APPROVED": 17,
  "CANCEL_-_REJECTED": 18,
  "CANCEL_-_REVIEWED": 19,
};

export const TRANSACTION_STATUS = {
  "REGISTER_-_PENDING_APPROVAL": 8,
  "REGISTER_-_REJECTED": 11,
  "REGISTER_-_REVIEWED": 12,
  "UPDATE_-_PENDING_APPROVAL": 9,
  "UPDATE_-_REJECTED": 14,
  "UPDATE_-_REVIEWED": 15,
  RECENTLY_UPDATE: 16,
};

export const CHANNEL_STATE_STRING_CREATE = {
  PENDING_APPROVAL: "REGISTER_PENDING_APPROVAL",
  REJECTED: "REGISTER_REJECTED",
  REVIEWED: "REGISTER_REVIEWED",
  APPROVED: "REGISTER_APPROVED",
};
export const CHANNEL_STATE_STRING_UPDATE = {
  PENDING_APPROVAL: "UPDATE_PENDING_APPROVAL",
  REJECTED: "UPDATE_REJECTED",
  REVIEWED: "UPDATE_REVIEWED",
  APPROVED: "UPDATE_APPROVAL",
};

export const REGISTER_STATUS = [
  CHANNEL_STATE["REGISTER_-_PENDING_APPROVAL"],
  CHANNEL_STATE["REGISTER_-_REJECTED"],
  CHANNEL_STATE["REGISTER_-_REVIEWED"],
];

export const UPDATE_STATUS = [
  CHANNEL_STATE["UPDATE_-_PENDING_APPROVAL"],
  CHANNEL_STATE["UPDATE_-_REVIEWED"],
];

export const CANCEL_STATUS = [
  CHANNEL_STATE["CANCEL_-_PENDING_APPROVAL"],
  CHANNEL_STATE["CANCEL_-_REVIEWED"],
];

export const INACTIVE_STATUS = [CHANNEL_STATE["CANCEL_-_APPROVED"]];

export const SORT_CRITERIA = {
  code: "Channel Code",
  name: "Channel Name",
  tier: "Channel Tier",
  updatedAt: "Recent Update",
  createdAt: "Create Time",
  status: "Channel Status",
};

export const TRANSACTION_TYPE = {
  CASH_IN_BANK: "Cash in bank",
  CASH_ON_HAND: "Cash on hand",
  ACCOUNT_TRANSFER: "Account transfer",
};

export const PAYMENT_METHOD = {
  CASH_IN_BANK: 2,
  CASH_ON_HAND: 1,
  ACCOUNT_TRANSFER: 3,
};

export const PAPER_TYPE = {
  ID_CARD_FRONT: 9,
  ID_CARD_BACK: 10,
  PORTRAIT: 11,
  CONTRACT: 2,
  BUSINESS_LICENSE: 12,
  OTHER: 13,
  SHOP_IMAGE: 14,
  CONTRACT_HARD_COPY: 15,
  AGREEMENT_CONTRACT: 2,
};

export const CHANNEL_ID_TYPE = {
  CIN_CID: "PPCC",
  PASSPORT: "PPRT",
  NIF: "PNIF",
};

export const APPROVE_STATUS = {
  PENDING_APPROVAL: 9,
  APPROVED: 10,
  REJECTED: 11,
};

export const CANCEL_APPROVE_STATUS = {
  CANCEL_PENDING_APPROVAL: "Pending Approval",
  CANCEL_REVIEWED: "Reviewed",
  CANCEL_REJECTED: "Rejected",
  CANCEL_APPROVED: "Approved",
};

export const CLEAR_DEBIT_STATUS = {
  PENDING_APPROVAL: 9,
  APPROVED: 13,
  REJECTED: 14,
};

export const OptionsTmp = [
  { label: "option-1", value: 1 },
  { label: "option-2", value: 2 },
  { label: "option-3", value: 3 },
  { label: "option-4", value: 4 },
];

export const GenderOpions = [
  { label: "male", value: 1 },
  { label: "female", value: 2 },
  { label: "other", value: 3 },
];

export const GenderTextOpions = [
  { label: "male", value: "MALE", oldValue: "1" },
  { label: "female", value: "FEMALE", oldValue: "2" },
  { label: "other", value: "OTHER", oldValue: "3" },
];

export const PREFIX = { USD: "$ " };
export const SUFFIX = { USD: " USD" };

export const OptionsIdType = [
  { label: "electoral-card", value: 1 },
  { label: "bi-card", value: 2 },
  { label: "passport", value: 3 },
];
export const OptionsPaperType = [
  { label: "id_card_front", value: 1 },
  { label: "id_card_back", value: 2 },
  { label: "portrait", value: 4 },
  { label: "contract", value: 5 },
  { label: "business_license", value: 6 },
  { label: "other", value: 7 },
];
export const SelectedPrivilegeAll = { label: "ALL", value: 7 };
export const OptionsPrivilege = [
  { label: "POS", value: 1 },
  { label: "PAYSALE", value: 2 },
  { label: "AIRTIME", value: 4 },
  //{ label: "POS_PAYSALE", value: 3 },
  //{ label: "POS_AIRTIME", value: 5 },
  //{ label: "PAYSALE_AIRTIME", value: 6 },
  //{ label: "ALL", value: 7 },
];
export const OptionsPrivilegeFull = [
  { label: "POS", value: 1 },
  { label: "PAYSALE", value: 2 },
  { label: "AIRTIME", value: 4 },
  { label: "POS_PAYSALE", value: 3 },
  { label: "POS_AIRTIME", value: 5 },
  { label: "PAYSALE_AIRTIME", value: 6 },
  SelectedPrivilegeAll,
];
export const OptionsCountry = [
  // { label: "Timor - Leste (East Timor)", value: "TL" },
  { label: "Haiti", value: "HT" },
];

export const ACTION_ALLOW = {
  isView: true,
  isEdit: true,
  isCreate: true,
  isRemove: true,
  confirmPending: true,
  confirm: true,
  //etc...
};
// export const ACTION = _.reduce(
//   ACTION_ALLOW,
//   function (result, value, key) {
//     result[key] = false;
//     return result;
//   },
//   {}
// );
export const KEY_ROLE_BIZZ_UAA = "role-current-UAA";
export const KEY_CHANNEL_CURRENT_USER = "channel-current-user";
export const KEY_LIST_ROLE_BIZZ_UAA = "list-role-current-UAA";
export const KEY_LIST_ACTIVE_ROLE = "user";
export const ROLE = {
  ADMIN: "ADMIN",

  HO_STAFF: "HO_STAFF",
  HO_BO: "HO_BO",
  HO_REVIEWER: "HO_REVIEWER",

  SA_EXTERNAL_STAFF: "SA_EXTERNAL_STAFF",
  SA_EXTERNAL_BO: "SA_EXTERNAL_BO",
  SA_EXTERNAL_REVIEWER: "SA_EXTERNAL_REVIEWER",
  SUB_SUPER_AGENT_EXTERNAL: "SUB_SUPER_AGENT_EXTERNAL",

  AGENT_EXTERNAL: "AGENT_EXTERNAL",
  AGENT_IN_SHOP_EXTERNAL: "AGENT_IN_SHOP_EXTERNAL",
  AGENT_KEY_EXTERNAL: "AGENT_KEY_EXTERNAL",

  MD_EXTERNAL_STAFF: "MD_EXTERNAL_STAFF",
  MD_EXTERNAL_REVIEWER: "MD_EXTERNAL_REVIEWER",
  MD_EXTERNAL_BO: "MD_EXTERNAL_BO",
};

export const KEY_LOCAL = {
  LANGUAGE: "languageCode",
};
